<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <div class="container">
      <e-search
        :data="filterInfo.data"
        :field-list="filterInfo.fieldList"
        :list-type-info="listTypeInfo"
        :count="10"
        @handleFilter="handleSearch"
        @handleReset="handleClear"
      ></e-search>
    </div>

    <div class="container">
      <div style="margin-bottom: 20px">
        <eui-btn type="primary" @click="handleAddAgreement">新增协议</eui-btn>
      </div>
      <TableList
        max-height="600"
        :loading="loading"
        :table-data="tableData"
        :table-label="tableLabel"
        @handleSortChange="handleSortChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <template #status="slot">
          <div style="font-size: 12px">
            {{ formatStatus(slot.scope.row.externalStatus) }}
          </div>
        </template>
        <template #agreementName="slot">
          <div
            style="
              cursor: pointer;
              color: #0064c8;
              font-size: 12px;
              text-align: center;
            "
            class="in2clamp"
            @click="checkDetail(slot.scope.row)"
          >
            {{ slot.scope.row.agreementName }}
          </div>
        </template>
        <template #productList="slot">
          <eui-btn
            type="text"
            font-size="12px"
            @click.native.prevent="checkProduct(slot.scope.row)"
            >查看</eui-btn
          >
        </template>
        <template #purchaserList="slot">
          <eui-btn
            type="text"
            font-size="12px"
            @click.native.prevent="checkPurchaser(slot.scope.row)"
            >查看</eui-btn
          >
        </template>
        <template #operation="slot">
          <!--非集采才可以操作-->
          <div v-if="slot.scope.row.collectType === 1">
            <eui-btn
              v-if="
                judgePurchaser(slot.scope.row) && handleStopFlag(slot.scope.row)
              "
              type="text"
              font-size="12px"
              @click.native.prevent="handleStop(slot.scope.row)"
              >停用</eui-btn
            >

            <eui-btn
              v-if="
                judgePurchaser(slot.scope.row) &&
                handleStartFlag(slot.scope.row)
              "
              type="text"
              font-size="12px"
              @click.native.prevent="handleStart(slot.scope.row)"
              >启用</eui-btn
            >

            <eui-btn
              v-if="judgePurchaser(slot.scope.row) && judgeEdit(slot.scope.row)"
              type="text"
              font-size="12px"
              @click.native.prevent="handleEdit(slot.scope.row)"
              >编辑</eui-btn
            >

            <eui-btn
              v-if="
                judgePurchaser(slot.scope.row) &&
                (slot.scope.row.externalStatus === 7 ||
                  slot.scope.row.externalStatus === 4 ||
                  (slot.scope.row.priceCount == 0 &&
                    slot.scope.row.externalStatus === 1)) &&
                slot.scope.row.source == 'GLF'
              "
              type="text"
              font-size="12px"
              @click.native.prevent="handleDelete(slot.scope.row)"
              >删除</eui-btn
            >

            <eui-btn
              v-if="
                judgePurchaser(slot.scope.row) &&
                (slot.scope.row.externalStatus === 0 ||
                  slot.scope.row.externalStatus === 2 ||
                  slot.scope.row.externalStatus === 6)
              "
              type="text"
              font-size="12px"
              @click.native.prevent="handleConfirmPrice(slot.scope.row)"
              >协议价确认</eui-btn
            >
          </div>
        </template>
        <template #agreementCode="slot">
          <div style="text-align: center">
            <p style="font-size: 12px; display: inline-block; white-space: pre">
              {{ slot.scope.row.agreementCode }}
            </p>
          </div>
        </template>
        <template #firstParty="slot">
          <div style="font-size: 12px; text-align: center">
            {{ slot.scope.row.firstParty }}
          </div>
        </template>
        <template #startDate="slot">
          <div style="text-align: center">
            <div style="font-size: 12px">{{ slot.scope.row.startDate }}</div>
          </div>
        </template>
        <template #endDate="slot">
          <div style="text-align: center">
            <div style="font-size: 12px">{{ slot.scope.row.endDate }}</div>
          </div>
        </template>
        <template #supplierCompanyName="slot">
          <div style="font-size: 12px; text-align: center">
            {{ slot.scope.row.supplierCompanyName }}
          </div>
        </template>
      </TableList>
      <div class="pagination">
        <el-pagination
          :page-sizes="[10, 20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="productTagPage.currentPage"
          :page-size="productTagPage.pageSize"
          :total="productTagPage.pageTotal"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <purchaser-list-dialog
      v-if="purchaserListDialogShow"
      :agreement-id="agreementId"
      :dialog-title="dialogTitle"
      :visible="purchaserListDialogShow"
      @close="closePurchaserListDialog"
    ></purchaser-list-dialog>
    <product-list-dialog
      v-if="productListDialogShow"
      :supplier-company-id="supplierCompanyId"
      :user-identity="2"
      :agreement-id="agreementId"
      :visible="productListDialogShow"
      @close="closeProductListDialog"
    ></product-list-dialog>
    <!--集采商品清单-->
    <jc-product-dialog
      v-if="jcProductListDialogShow"
      :supplier-company-id="supplierCompanyId"
      :user-identity="2"
      :agreement-id="agreementId"
      :visible.sync="jcProductListDialogShow"
      @close="closeProductListDialog"
    />
  </div>
</template>

<script>
import TableList from '../../components/common/e-table-list';
import PurchaserListDialog from '../../components/agreement/agreementManage/pachurserListDialog';
import ProductListDialog from '../../components/agreement/agreementManage/productDialog';
import agreementApi from '../../api/agreement/index';
import ESearch from '../../components/common/e-search';
import { epecMallUrl } from '../../api/config';
import jcProductDialog from '../../components/agreement/agreementManage/jcProductDialog';

export default {
  name: 'AgreementManage',
  components: {
    TableList,
    PurchaserListDialog,
    ProductListDialog,
    ESearch,
    jcProductDialog,
  },
  props: {},
  data() {
    return {
      jcProductListDialogShow: false,
      query: {
        supplierCompanyName: '',
        externalStatus: '',
        firstParty: '',
        agreementCode: '',
        agreementName: '',
        skuName: '',
        sourcePlatform: '',
      },
      loading: false,
      tableData: [],
      tableLabel: [
        // { label: '序号', type:'index',  align: 'center',fixed:'left'},
        {
          label: '协议编号',
          param: 'agreementCode',
          align: 'center',
          minWidth: '200',
          slot: 'agreementCode',
        },
        {
          label: '协议名称',
          param: 'agreementName',
          align: 'center',
          slot: 'agreementName',
          minWidth: '200',
        },
        {
          label: '协议甲方',
          param: 'firstParty',
          align: 'center',
          minWidth: '200',
          slot: 'firstParty',
        },
        {
          label: '供应商名称',
          param: 'supplierCompanyName',
          align: 'center',
          minWidth: '210',
          slot: 'supplierCompanyName',
        },
        {
          label: '采购商清单',
          param: 'purchaserList',
          align: 'center',
          slot: 'purchaserList',
          minWidth: '100',
        },
        {
          label: '商品清单',
          param: 'productList',
          align: 'center',
          slot: 'productList',
          minWidth: '100',
        },
        {
          label: '开始时间',
          param: 'startDate',
          align: 'center',
          minWidth: '100',
          slot: 'startDate',
        },
        {
          label: '结束时间',
          param: 'endDate',
          align: 'center',
          minWidth: '100',
          slot: 'endDate',
        },
        {
          label: '协议类型',
          param: 'collectType',
          align: 'center',
          minWidth: '100',
          render: (row) => {
            if (row.collectType === 1) {
              return '非集采';
            }
            if (row.collectType === 0) {
              return '集采';
            }
          },
        },
        {
          label: '协议状态',
          param: 'externalStatus',
          align: 'center',
          slot: 'status',
          minWidth: '100',
        },
        {
          label: '操作',
          align: 'center',
          slot: 'operation',
          minWidth: '200',
          fixed: 'right',
        },
      ],
      productTagPage: {
        currentPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      purchaserListDialogShow: false,
      productListDialogShow: false,
      dialogTitle: '采购商列表',
      agreementId: null,
      supplierCompanyId: null,
      filterInfo: {
        data: {
          supplierCompanyName: '',
          externalStatus: '',
          firstParty: '',
          agreementCode: '',
          agreementName: '',
          skuName: '',
          sourcePlatform: '',
          collectType: null,
        },
        fieldList: [
          { label: '协议编号', type: 'input', value: 'agreementCode' },
          { label: '协议名称', type: 'input', value: 'agreementName' },
          { label: '协议甲方名称', type: 'input', value: 'firstParty' },
          { label: '供应商名称', type: 'input', value: 'supplierCompanyName' },
          // { label: '采购商清单',  type: 'input', value: 'purchaserList'},
          // { label: '商品清单',   type: 'input', value: 'productList'},
          // { label: '开始时间',  type: 'date', value: 'startDate' },

          {
            label: '协议状态',
            type: 'select',
            value: 'externalStatus',
            list: 'statusList',
          },
          {
            label: '协议来源',
            type: 'select',
            value: 'sourcePlatform',
            list: 'agreementTypeList',
          },
          {
            label: '协议类型',
            type: 'select',
            value: 'collectType',
            list: 'collectTypeList',
          },
        ],
        /** 搜索/重置区域是否隐藏 */
        // btnHidden: true,
        /** 组件尺寸 */
        // size: 'small',
        /** 默认展示搜索条件 */
        count: 100,
        /** label/item 宽度 */
        // width: {
        //   labelWidth: 110,
        //   itemWidth: 220
        // },
        /** 配置项 */
        btnStyle: [
          { icon: 'el-icon-search', text: '过滤', type: 'primary' },
          { icon: 'el-icon-refresh', text: '重置' },
        ],
      },
      listTypeInfo: {
        collectTypeList: [
          { id: null, name: '全部' },
          { id: 0, name: '集采' },
          { id: 1, name: '非集采' },
        ],
        statusList: [
          { id: 1, name: '待添加商品' },
          { id: 2, name: '已生效' },
          { id: 4, name: '已停用' },
          { id: 6, name: '待确认价格' },
          { id: 7, name: '已失效' },
          { id: 0, name: '待生效' },
        ],
        agreementTypeList: [
          { id: 0, name: '平台创建' },
          { id: 1, name: '渠道同步' },
        ],
      },
      isMaintance: false, // 判断供应商是否维护商品
      isOpen: false, // 判断用户是否开通采购专属商城
    };
  },
  computed: {},
  watch: {
    $route() {
      this.handleClear();
    },
  },
  created() {
    this.getAgreementList();
    this.isOpenPurchaseZone();
    // this.getAgreementType()
  },
  activated() {
    this.getAgreementList();
  },
  methods: {
    async handleAddAgreement() {
      if (this.isOpen || this.$store.state.USERINFO.internalFlag) {
        this.$router.push({ path: '/agreementAdd' });
      } else {
        this.$message({
          type: 'warning',
          message:
            `请您开通采购专属商城（${epecMallUrl}/purchaseZone` +
            `），使用框架协议功能`,
        });
      }
    },
    handleSearch(val) {
      this.filterInfo.data = val;
      this.productTagPage.currentPage = 1;
      this.productTagPage.pageSize = 10;
      const params = this.formatParams(val);
      this.getAgreementList(params);
    },
    handleClear() {
      this.filterInfo.data.agreementCode = '';
      this.filterInfo.data.agreementName = '';
      this.filterInfo.data.supplierCompanyName = '';
      this.filterInfo.data.externalStatus = '';
      this.filterInfo.data.firstParty = '';
      this.productTagPage.currentPage = 1;
      this.productTagPage.pageSize = 10;
      this.filterInfo.data.sourcePlatform = '';
      this.filterInfo.data.collectType = null;
      const params = {
        pageNum: 1,
        pageSize: 10,
        agreementCode: '',
        agreementName: '',
        supplierCompanyName: '',
        externalStatus: '',
        firstParty: '',
        sourcePlatform: '',
        collectType: null,
      };
      this.getAgreementList(params);
    },
    handleSortChange() {},
    handleSelectionChange() {},
    handleSizeChange(val) {
      console.log(this.filterInfo.data);
      this.productTagPage.pageSize = val;
      this.productTagPage.currentPage = 1;
      const params = {
        pageNum: this.productTagPage.currentPage,
        pageSize: this.productTagPage.pageSize,
        agreementCode: this.filterInfo.data.agreementCode,
        agreementName: this.filterInfo.data.agreementName,
        supplierCompanyName: this.filterInfo.data.supplierCompanyName,
        externalStatus: this.filterInfo.data.externalStatus,
        firstParty: this.filterInfo.data.firstParty,
      };
      this.getAgreementList(params);
    },
    handleCurrentChange(val) {
      console.log(this.filterInfo.data);
      this.productTagPage.currentPage = val;
      const params = {
        pageNum: this.productTagPage.currentPage,
        pageSize: this.productTagPage.pageSize,
        agreementCode: this.filterInfo.data.agreementCode,
        agreementName: this.filterInfo.data.agreementName,
        supplierCompanyName: this.filterInfo.data.supplierCompanyName,
        externalStatus: this.filterInfo.data.externalStatus,
        firstParty: this.filterInfo.data.firstParty,
      };
      this.getAgreementList(params);
    },
    handleEdit(val) {
      this.$router.push({
        name: 'agreementEdit',
        query: { agreementId: val.agreementId },
      });
    },
    handleDelete(val) {
      this.$confirm('协议删除后不可恢复，确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const params = {
            agreementId: val.agreementId,
          };
          agreementApi.deleteAgreement(params).then((res) => {
            if (res.code === '200') {
              this.$message({
                type: 'success',
                message: '删除成功!',
              });
            } else {
              this.$message({
                type: 'error',
                message: '删除失败!',
              });
            }
            this.getAgreementList();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    handleStop(val) {
      this.$confirm('协议停用后协议将失效，确认停用吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const params = {
            agreementId: val.agreementId,
          };
          agreementApi.stopAgreement(params).then((res) => {
            if (res.code === '200') {
              this.$message({
                type: 'success',
                message: '停用成功!',
              });
            } else {
              this.$message({
                type: 'error',
                message: '停用失败!',
              });
            }
            this.getAgreementList({
              ...this.filterInfo.data,
              ...this.productTagPage,
            });
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消停用',
          });
        });
    },
    handleStart(val) {
      this.$confirm('确认启用吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const params = {
            agreementId: val.agreementId,
          };
          agreementApi.startAgreement(params).then((res) => {
            if (res.code === '200') {
              this.$message({
                type: 'success',
                message: '启用成功!',
              });
            } else {
              this.$message({
                type: 'error',
                message: '启用失败!',
              });
            }
            this.getAgreementList({
              ...this.filterInfo.data,
              ...this.productTagPage,
            });
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消启用',
          });
        });
    },
    handleConfirmPrice(val) {
      this.$router.push({
        name: 'agreementConfirm',
        query: { agreementId: val.agreementId },
      });
    },
    checkDetail(val) {
      this.$router.push({
        path: '/agreementDetail',
        query: { agreementId: val.agreementId },
      });
      // let params = {
      //     agreementId: val.agreementId
      // }
      // agreementApi.getAgreementDetail(params)
      //     .then((res) => {
      //         if(res.data){
      //             this.$router.push({name:'agreementDetail', params:{agreementDetail: res.data}})
      //         }
      //     })
    },
    checkProduct(val) {
      // 0 集采 ,1 非集采
      if (Number(val.collectType) === 1) {
        // 非集采
        this.productListDialogShow = true;
      } else {
        this.jcProductListDialogShow = true;
      }
      this.agreementId = val.agreementId;
      this.supplierCompanyId = val.supplierCompanyId;
    },
    checkPurchaser(val) {
      this.agreementId = val.agreementId;
      this.purchaserListDialogShow = true;
    },
    closeProductListDialog() {
      this.productListDialogShow = false;
      this.jcProductListDialogShow = false;
    },
    closePurchaserListDialog() {
      this.purchaserListDialogShow = false;
    },
    getAgreementList(val) {
      // let params = this.formatParams(val);
      agreementApi
        .getAgreementListForPurchase(val)
        .then((res) => {
          this.tableData = res.data.records;
          this.productTagPage.pageTotal = res.data.total;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    formatParams(params) {
      const res = {};
      res.agreementCode = params.agreementCode;
      res.agreementName = params.agreementName;
      res.supplierCompanyName = params.supplierCompanyName;
      res.externalStatus = params.externalStatus;
      res.firstParty = params.firstParty;
      res.sourcePlatform = params.sourcePlatform;
      res.collectType = params.collectType;
      res.pageSize = this.productTagPage.pageSize;
      res.pageNum = this.productTagPage.currentPage;
      return res;
    },
    formatStatus(val) {
      let res = '';
      switch (val) {
        case 0:
          res = '待生效';
          break;
        case 1:
          res = '待添加商品';
          break;
        case 2:
          res = '已生效';
          break;
        case 4:
          res = '已停用';
          break;
        // case 5: res='启用';break;
        case 6:
          res = '待确认价格';
          break;
        case 7:
          res = '已失效';
          break;
      }
      return res;
    },
    judgeEdit(row) {
      // 仅在协议停用时，盐湖协议甲方可编辑协议执行方，启用的协议不显示编辑按钮
      if (
        (row.externalStatus === 4 || row.externalStatus === 1) &&
        row.source == 'SL'
      ) {
        return true;
      }
      // 延用之前逻辑
      if (
        (row.externalStatus === 7 ||
          row.externalStatus === 4 ||
          (row.priceCount == 0 && row.externalStatus === 1)) &&
        row.source == 'GLF'
      ) {
        return true;
      }
      return false;
    },
    // 启用
    handleStartFlag(row) {
      if (
        row.externalStatus === 4 &&
        (row.source == 'GLF' || row.source == 'SL')
      ) {
        return true;
      }
      return false;
    },
    // 停用
    handleStopFlag(row) {
      if (
        (row.externalStatus === 2 || row.externalStatus === 0) &&
        row.source == 'SL'
      ) {
        return true;
      }
      if (
        (row.externalStatus === 0 || row.externalStatus === 2) &&
        row.source == 'GLF'
      ) {
        return true;
      }
      return false;
    },
    judgePurchaser(val) {
      return (
        val.epecBelongCompanyId ==
        JSON.parse(localStorage.getItem('USERINFO')).companyId
      );
    },
    judgeDoubleIdentity(val) {
      return (
        (JSON.parse(localStorage.getItem('USERINFO')).identity ==
          'double_identity' ||
          JSON.parse(localStorage.getItem('USERINFO')).identity ==
            'supplier') &&
        JSON.parse(localStorage.getItem('USERINFO')).companyId ==
          val.supplierCompanyId
      );
    },
    async judgeMaintanceProduct(val) {
      const params = {
        agreementId: val.agreementId,
        supplierCompanyId: val.supplierCompanyId,
      };

      const res = await agreementApi.isMaintanceProduct(params);
      if (res.data > 0) {
        this.isMaintance = true;
      }
    },
    async isOpenPurchaseZone() {
      const res = await agreementApi.isOpenPurchaseZone();
      this.isOpen = res.data;
    },
    async getAgreementType() {
      const res = await agreementApi.getAgreementType();
      if (res.code == '200') {
        for (let i = 0; i < res.data.length; i++) {
          const arr = {};
          arr.id = res.data[i];
          arr.name = res.data[i];
          this.listTypeInfo.agreementTypeList.push(arr);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.delete-btn.el-button--text {
  color: #f0250f;
  font-size: 12px;
  cursor: pointer;
}
.e-search {
  margin-bottom: 20px;
}
</style>
